import { reactive, toRefs } from "@vue/composition-api";

let showSpinner = null;

export function useShowSpinner() {
  if (showSpinner === null) {
    showSpinner = reactive({
      loading: false,
    });
  }

  function setShowSpinner(truthy) {
    showSpinner.loading = truthy;
  }

  return {
    ...toRefs(showSpinner),
    setShowSpinner,
  };
}
